import styled from 'styled-components'

import theme from 'theme_'
import { Regular } from 'components/Typography'

export const StyledDescriptionText = styled(Regular)`
  text-align: center;
  margin-bottom: ${theme.spacing.md};
`
